package app.footyguide.web.data

/** A filter clause: field operator value. */
data class WhereClause(val field: String, val op: String, val value: Any)

/** An order clause: field + direction ("asc"|"desc"). */
data class OrderClause(val field: String, val direction: String)

/**
 * Builder for Firestore structured queries.
 *
 * Stores typed where/order clauses consumed by [FirestoreSdk.runQuery].
 */
class StructuredQuery(
    val collectionId: String,
    val allDescendants: Boolean = false,
) {
    private val _wheres = mutableListOf<WhereClause>()
    private val _orders = mutableListOf<OrderClause>()
    var limitCount: Int? = null

    val wheres: List<WhereClause> get() = _wheres.toList()
    val orders: List<OrderClause> get() = _orders.toList()

    fun where(field: String, op: String, value: Any): StructuredQuery {
        _wheres.add(WhereClause(field, op, value))
        return this
    }

    fun orderBy(field: String, direction: String = "asc"): StructuredQuery {
        _orders.add(OrderClause(field, direction))
        return this
    }

    fun limit(count: Int): StructuredQuery {
        limitCount = count
        return this
    }

}
